(() => {
  if (window.wspGiftDisplayNamesReady) return;
  window.wspGiftDisplayNamesReady = true;
  const replaceNames = () => {
    const lang = (document.documentElement.lang || 'zh').slice(0, 2);
    const names = lang === 'en' ? {back_scratcher: 'Back Scratcher', massage_tapper: 'WSP Massage Tapper'} : lang === 'ms' ? {back_scratcher: 'Penggaru Belakang', massage_tapper: 'Penepuk Urut WSP'} : {back_scratcher: '不求人', massage_tapper: '黄叔平拍八虚'};
    document.querySelectorAll('.wsp48-sheet-gift-text').forEach(el => {
      const text = el.textContent.replace(/back_scratcher|massage_tapper/g, code => names[code]);
      if (text !== el.textContent) el.textContent = text;
    });
  };
  const start = () => {
    replaceNames();
    new MutationObserver(replaceNames).observe(document.body, {subtree: true, childList: true, characterData: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();